import React from "react";
import { IconButton, Tooltip } from "@mui/material";

const PATIconButton = ({ title, onClick, icon }) => {
  return (
    <Tooltip title={title}>
      <IconButton onClick={onClick}>
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default PATIconButton;
